/* CrispyCards Cart Upsell – installed once, scoped to CartDrawer. */
(() => {
  'use strict';
  if (window.__ccCartUpsellReady) return;
  window.__ccCartUpsellReady = true;

  document.addEventListener('click', async (event) => {
    const dismiss = event.target.closest('[data-cc-upsell-dismiss]');
    if (dismiss && dismiss.closest('#CartDrawer')) {
      event.preventDefault();
      const card = dismiss.closest('[data-cc-upsell]');
      if (card) card.remove();
      return;
    }

    const button = event.target.closest('#CartDrawer .crispy-upsell-btn');
    if (!button || button.disabled) return;
    event.preventDefault();
    const card = button.closest('[data-cc-upsell]');
    if (!card) return;
    const selector = card.querySelector('.crispy-upsell-variant');
    const id = Number(selector ? selector.value : button.dataset.defaultVariant);
    const error = card.querySelector('.crispy-upsell-error');
    if (!Number.isSafeInteger(id) || id <= 0) return;
    if (error) { error.hidden = true; error.textContent = ''; }
    button.disabled = true;
    button.textContent = 'Wird hinzugefügt …';
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id, quantity: 1 })
      });
      if (!response.ok) {
        const detail = await response.json().catch(() => ({}));
        throw new Error(detail.description || detail.message || 'Konnte nicht hinzugefügt werden.');
      }
      const addedItem = await response.json();
      card.remove();
      // Impulse's native CartDrawer listener rebuilds the cart and keeps it open.
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: addedItem } }));
    } catch (err) {
      if (error) { error.textContent = err.message || 'Bitte erneut versuchen.'; error.hidden = false; }
    } finally {
      button.disabled = false;
      button.textContent = '+ Hinzufügen';
    }
  });
})();
